
<div class="controls">
    <div class="firstCntrls">
        <div>
            <mat-form-field class="filter">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. 280" #input>
            </mat-form-field>
        </div>
        <div class="dates">
            <div>
                <mat-form-field class="date1">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="strtPicker" [formControl]="startDate" (focus)="strtPicker.open()" data-test="date1" readonly>
                    <mat-datepicker-toggle matSuffix [for]="strtPicker"></mat-datepicker-toggle>
                    <mat-datepicker #strtPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="date2">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="picker" [formControl]="endDate" (focus)="picker.open()" data-test="date2" readonly>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <button mat-raised-button (click)="click()" [disabled]="!startDate.value || !endDate.value || downloading" data-test="search">Search</button>
            </div>
        </div>
    </div>
    <div class="secondCntrls">
        <app-export [data]="selection.selected" [disabled]="selection.selected.length == 0"></app-export>
        <mat-paginator
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons>
        </mat-paginator>
    </div>
</div>
<div class="rectable">
    <table mat-table [dataSource]='data' matSort multiTemplateDataRows data-test="table">
    
        <ng-container matColumnDef="{{col}}" *ngFor="let col of displayedColumns; let i = index">
            <div *ngIf="col !== 'select'">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ headerTxt[i] }}</th>
                <td mat-cell *matCellDef="let row"> {{row[col]}} </td>
            </div>
            <div *ngIf="col === 'select'">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)">
                    </mat-checkbox>
                </td>
            </div>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"
            class="element-row"
            (click)="openDialog(element.id)">
        </tr>
    </table>
</div>

